module.exports = __webpack_public_path__ + "img/ar-app-banner.2f5bd98d.webp";